import { colors } from "../../Styles";

export function OnOff({rotate = 0, size = "20px", fillColor = colors.greyLightTertiary}) {
  return (

      <svg style={{ transform: `rotate(${rotate}deg)`, display: "inline-block", transformOrigin: "15px 15.6px" }} height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
        <path d="M177.38,18.99l-6.98,25.14c46.03,12.78,78.18,55.12,78.18,102.96,0,58.92-47.93,106.85-106.85,106.85s-106.85-47.93-106.85-106.85c0-47.15,31.57-89.33,76.78-102.56l-7.33-25.04c-27.02,7.91-51.34,24.67-68.47,47.19-17.71,23.28-27.07,51.09-27.07,80.41,0,73.3,59.63,132.93,132.93,132.93s132.93-59.63,132.93-132.93c0-59.51-40.01-112.19-97.29-128.09h.02Z"/>
        <path d="M141.73,163.95c7.2,0,13.04-5.84,13.04-13.04V16.49c0-7.2-5.84-13.04-13.04-13.04s-13.04,5.84-13.04,13.04v134.42c0,7.2,5.84,13.04,13.04,13.04Z"/>
      </svg>
  );
}
